export default {
  terms:
    'En passant votre commande, vous acceptez nos <TermsLink>Conditions générales</TermsLink> et notre <PrivacyPolicyLink>Politique de confidentialité</PrivacyPolicyLink>.',
};
